import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Full-screen curtain on first load — a two-panel wipe with the
// brand name masked-revealed. Runs once, then unmounts.
export const LoaderCurtain = () => {
	const [done, setDone] = useState(false);

	useEffect(() => {
		const t = setTimeout(() => setDone(true), 1500);
		return () => clearTimeout(t);
	}, []);

	return (
		<AnimatePresence>
			{!done && (
				<motion.div
					initial={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.4 }}
					className="fixed inset-0 z-[80] flex overflow-hidden pointer-events-none"
					aria-hidden
				>
					<motion.div
						initial={{ y: 0 }}
						animate={{ y: '-100%' }}
						transition={{
							delay: 1.0,
							duration: 0.9,
							ease: [0.76, 0, 0.24, 1],
						}}
						className="flex-1 bg-brand-navy flex items-end justify-start p-8"
					>
						<span className="font-chivo text-white/60 text-[11px] uppercase tracking-[0.3em] font-bold">
							Breakdownexperts
						</span>
					</motion.div>
					<motion.div
						initial={{ y: 0 }}
						animate={{ y: '100%' }}
						transition={{
							delay: 1.0,
							duration: 0.9,
							ease: [0.76, 0, 0.24, 1],
						}}
						className="flex-1 bg-brand-red flex items-start justify-end p-8"
					>
						<span className="font-chivo text-white/80 text-[11px] uppercase tracking-[0.3em] font-bold">
							Dispatch · Live
						</span>
					</motion.div>

					<motion.div
						initial={{ opacity: 0, scale: 0.98 }}
						animate={{ opacity: 1, scale: 1 }}
						exit={{ opacity: 0 }}
						transition={{ delay: 0.15, duration: 0.5 }}
						className="absolute inset-0 flex items-center justify-center"
					>
						<div className="font-anton text-white text-[42px] sm:text-[80px] md:text-[120px] leading-none tracking-tight">
							<motion.span
								initial={{ opacity: 0, y: 20 }}
								animate={{ opacity: 1, y: 0 }}
								transition={{ delay: 0.25, duration: 0.6 }}
								className="inline-flex items-center gap-4"
							>
								<span className="w-3 h-3 sm:w-4 sm:h-4 bg-brand-red pulse-dot" />
								24 / 7
							</motion.span>
						</div>
					</motion.div>
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default LoaderCurtain;
